import { InjectionKey, Ref } from 'vue';
import { createContext, useContext } from '@/hooks/context';
import { cloneDeep } from 'lodash';

export type DefaultConfig = {
  prodStorehouse: Recordable;
  isDirectStoreIn: boolean;
  storehouse: Recordable;
  account: Recordable;
  mulSelectStaff: any[];
  pickOrderIsDirectOut: string;
  pickOrderIsDirectIn: string;
  printer: Recordable;
  showZeroPurchaseNumber: boolean;
  fillInAllCache: string;
  purchaseCountRule: number;
  isWorkTicketRowCopy: boolean;
};
export interface AppProviderContextProps {
  defaultConfig: DefaultConfig;
  setDefaultConfig: (params: Recordable) => void;
  getDefaultStorehouse: (params: Recordable) => Promise<void>;
  getDefaultMulStaff: (params: Recordable) => Promise<void>;
}
export const defaultConfig = {
  prodStorehouse: {}, // 关联生产单默认加工厂仓库
  isDirectStoreIn: 0, // 记住上次入库操作
  // 上次加工厂仓库
  storehouse: {
    storehouseId: '',
    storehouseName: '',
    storehouseType: undefined,
  },
  // 上次结算账户
  account: {
    accountId: '',
    accountName: '',
  },
  // 上次多选选择的人员
  mulSelectStaff: [],
  // 存储打印机停用的id数据
  printer: {
    unenableListSet: [],
  },
  fillInAllCache: 'number',
  // 显示预计采购数为0
  showZeroPurchaseNumber: false,
  // 物料采购单填入规则
  purchaseCountRule: 2,
  // 横向复制
  isWorkTicketRowCopy: true,
  // 尺寸指示分数与小数
  sizeDisplay: '1',
};
const defaultState = {
  defaultConfig: cloneDeep(defaultConfig),
};
export const APP_CONTEXXT: InjectionKey<AppProviderContextProps> =
  Symbol('APP_CONTEXXT');

export function createAppProviderContext<T>(
  context: AppProviderContextProps
): T;
export function createAppProviderContext(context: AppProviderContextProps) {
  return createContext<AppProviderContextProps>(context, APP_CONTEXXT, {
    readonly: false,
  });
}

export function useAppProviderContext() {
  const context = useContext<AppProviderContextProps>(
    APP_CONTEXXT,
    defaultState
  );
  return context;
}
